import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  container: {
    textAlign: "center",
    width: "100%",
  },
  border: {
    borderBottom: "1px solid #EAEDF0",
    width: "100%",
    lineHeight: "0.1em",
    margin: "10px 0 20px",
  },
  text: {
    color: "#181C1E",
    opacity: "0.8",
    background: "#fff",
    padding: "0 10px",
    fontSize: 12,
  },
  timeText: {
    color: "#8790A6",
  },
});

const SystemMessage = (props) => {
  const { text, time, classes, onClick } = props;

  return (
    <div className={classes.container} onClick={onClick}>
      <Typography variant="caption">{time}</Typography>
      <h2 className={classes.border}>
        <span className={classes.text}>{text}</span>
      </h2>
    </div>
  );
};

SystemMessage.propTypes = {
  text: PropTypes.string,
  time: PropTypes.object,
  name: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SystemMessage);
